const ToTree = (data) => {
    //var map = {}

    // create a {code: node} map
    var dataMap = data.reduce(function(map, node) {
        map[node.code] = node;
        return map;
    }, {});

    // create a hierarchical tree array
    var tree = [];
    data.forEach(function(node) {
        // find parent
        var parent = dataMap[node.parent];
        if (parent) {
            // create child array if it doesn't exist
            (parent.children || (parent.children = []))
                // add node to parent's child array
                .push(node);
        } else {
            // parent is null or missing
            tree.push(node);
        }
    });

    return tree;

    // for (var i = 0; i < flat.length; i++) {
    //     var obj = flat[i]
    //     obj.items= []

    //     map[obj.code] = obj

    //     var parent = obj.parent || '-'
    //     if (!map[parent]) {
    //         map[parent] = {
    //             items: []
    //         }
    //     }
        
    //     map[parent].items.push(obj)
    // }

    // return map['-'].items
}

export default ToTree